@if (!isAuthenticated) {
  <app-portal-navbar></app-portal-navbar>
}

<ion-content [fullscreen]="!isAuthenticated" [scrollEvents]="true">

  <!-- HERO -->
  <div class="hero" [class.hero--public]="!isAuthenticated" [class.hero--shell]="isAuthenticated">
    <div class="hero-grid-overlay"></div>
    <p class="eyebrow">{{ 'security.heroEyebrow' | translate }}</p>
    <h1>{{ 'security.heroTitleLine1' | translate }}<br><span class="gradient-text">{{ 'security.heroTitleLine2' | translate }}</span></h1>
    <p class="hero-sub">{{ 'security.heroSub' | translate }}</p>
  </div>

  <main>
    <!-- INTRO -->
    <section class="sec sec--narrow" aria-labelledby="sec-intro">
      <p class="section-eyebrow">{{ 'security.introEyebrow' | translate }}</p>
      <h2 class="section-title" id="sec-intro">{{ 'security.introTitle' | translate }}</h2>
      <p class="sec-text">{{ 'security.introText' | translate }}</p>
    </section>

    <!-- MEASURES -->
    <section class="sec" aria-labelledby="sec-measures">
      <p class="section-eyebrow">{{ 'security.measuresEyebrow' | translate }}</p>
      <h2 class="section-title" id="sec-measures">{{ 'security.measuresTitle' | translate }}</h2>
      <ul class="measure-grid">
        @for (m of measures; track m.titleKey) {
          <li class="measure">
            <span class="badge" aria-hidden="true"><ion-icon [name]="m.icon"></ion-icon></span>
            <h3>{{ m.titleKey | translate }}</h3>
            <p>{{ m.descKey | translate }}</p>
          </li>
        }
      </ul>
    </section>

    <!-- GM GUARDIAN -->
    <section class="sec" aria-labelledby="sec-guardian">
      <div class="guardian">
        <div class="guardian__copy">
          <span class="badge badge--lg" aria-hidden="true"><ion-icon name="shield-checkmark-outline"></ion-icon></span>
          <p class="section-eyebrow">{{ 'security.guardian.eyebrow' | translate }}</p>
          <h2 class="section-title" id="sec-guardian">{{ 'security.guardian.title' | translate }}</h2>
          <p class="sec-text">{{ 'security.guardian.lead' | translate }}</p>
          <p class="guardian__note">
            <ion-icon name="information-circle-outline" aria-hidden="true"></ion-icon>
            <span>{{ 'security.guardian.note' | translate }}</span>
          </p>
        </div>
        <ul class="guardian__points">
          @for (p of guardianPoints; track p.titleKey) {
            <li class="point">
              <span class="badge" aria-hidden="true"><ion-icon [name]="p.icon"></ion-icon></span>
              <div>
                <h3>{{ p.titleKey | translate }}</h3>
                <p>{{ p.descKey | translate }}</p>
              </div>
            </li>
          }
        </ul>
      </div>
    </section>

    <!-- TIPS -->
    <section class="sec sec--narrow" aria-labelledby="sec-tips">
      <p class="section-eyebrow">{{ 'security.tips.eyebrow' | translate }}</p>
      <h2 class="section-title" id="sec-tips">{{ 'security.tips.title' | translate }}</h2>
      <ul class="tips">
        @for (t of tips; track t.titleKey) {
          <li class="point">
            <span class="badge" aria-hidden="true"><ion-icon [name]="t.icon"></ion-icon></span>
            <div>
              <h3>{{ t.titleKey | translate }}</h3>
              <p>{{ t.descKey | translate }}</p>
            </div>
          </li>
        }
      </ul>
    </section>

    <!-- CONTACT -->
    <section class="contact" aria-labelledby="sec-contact">
      <span class="badge badge--lg" aria-hidden="true"><ion-icon name="mail-outline"></ion-icon></span>
      <p class="section-eyebrow">{{ 'security.contact.eyebrow' | translate }}</p>
      <h2 class="section-title" id="sec-contact">{{ 'security.contact.title' | translate }}</h2>
      <p class="sec-text">{{ 'security.contact.text' | translate }}</p>
      <p class="contact__mail">
        {{ 'security.contact.mailLead' | translate }}
        <a href="mailto:security@gastro-management.ch">security&#64;gastro-management.ch</a>
      </p>
      <div class="contact__actions">
        <a class="btn-hero" routerLink="/contact">
          {{ 'security.contact.button' | translate }}
          <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
        </a>
        @if (isAuthenticated) {
          <a class="btn-ghost" routerLink="/support">{{ 'security.contact.supportButton' | translate }}</a>
        }
      </div>
    </section>
  </main>

  <app-portal-footer></app-portal-footer>

</ion-content>
